import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import machine from './modules/machine';
import menu from './modules/menu';
import createPersistedState from 'vuex-persistedstate';
import alarm from './modules/alarms';
import paths from './modules/paths';
import fields from './modules/fields';
import update from './modules/update';
import missions from './modules/missions';
import notifications from './modules/notifications';
import missionReport from './modules/missionReport';
import SecureLS from 'secure-ls';
const ls = new SecureLS({ isCompression: false, encodingType: 'aes' });
const version = process.env.VUE_APP_VERSION;
const major = version?.split('.')[0];

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  modules: { global, machine, menu, alarm, paths, fields, missions, notifications, missionReport, update },
  plugins: [
    createPersistedState({
      paths: ['alarm', 'machine', 'notifications'],
      key: `vuex_v${major}`
      // storage: {
      //   getItem: key => ls.get(key),
      //   setItem: (key, value) => ls.set(key, value),
      //   removeItem: key => ls.remove(key)
      // }
    })
  ]
});
